import React from 'react';
import { CustomerByStationService, FluxClientStation } from 'types';
import styled from 'styled-components';
import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/lib/tooltip';
import { BASIC_ROW_HEIGHT, Basic, isValueStringEmpty } from './utils';

type TooltipKey = 'stationFullName';
interface Props {
  customerService: CustomerByStationService;
  fluxClientStationKey: keyof FluxClientStation;
  formatDisplay?: (value: Basic) => string;
  withToolTip?: boolean;
  tooltipPlacement?: TooltipPlacement;
  tooltipTitle?: string;
  tooltipKey?: TooltipKey;
}

type StyledFluxClientDisplayItemProps = {
  empty: boolean;
  hasException?: boolean;
};

const StyledFluxClientDisplayItem = styled.div<StyledFluxClientDisplayItemProps>`
  ${(props) => props.hasException && 'color: red'};
  height: ${BASIC_ROW_HEIGHT}px;
  padding-top: 5px;
  padding-bottom: 5px;
  &:not(:last-child) {
    border-bottom: 2px solid #d8d8d8;
  }
  &:after {
    content: ${(props) => (props.empty ? '"\xA0"' : '""')};
  }
`;

const FluxClientDisplay: React.FC<Props> = ({
  tooltipPlacement = 'left',
  tooltipTitle = 'title',
  customerService,
  fluxClientStationKey,
  formatDisplay,
  withToolTip,
  tooltipKey,
}) => {
  return (
    <div>
      {customerService?.fluxClientStations &&
        customerService?.fluxClientStations.map((fluxClientStation) => (
          <StyledFluxClientDisplayItem
            key={`${fluxClientStationKey}_${fluxClientStation.uicStation}`}
            empty={isValueStringEmpty(fluxClientStation[fluxClientStationKey])}
            hasException={customerService.isCancel || fluxClientStation.isStopSkip}
          >
            {!!withToolTip && (
              <Tooltip title={tooltipKey ? fluxClientStation[tooltipKey] : tooltipTitle} placement={tooltipPlacement}>
                {formatDisplay
                  ? formatDisplay(fluxClientStation[fluxClientStationKey])
                  : fluxClientStation[fluxClientStationKey]}
              </Tooltip>
            )}
            {!withToolTip && (
              <>
                {formatDisplay
                  ? formatDisplay(fluxClientStation[fluxClientStationKey])
                  : fluxClientStation[fluxClientStationKey]}
              </>
            )}
          </StyledFluxClientDisplayItem>
        ))}
    </div>
  );
};

export default FluxClientDisplay;
